module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-35.705fe8ed.jpg";